import { useState } from 'react';
import { get } from 'lodash';
import { useMutation, ajaxExceptionMessage } from '@skunexus/utils';
import * as API from '../api';

export const useDivisions = ({ errorNotification = () => {} }) => {
    const [divisions, setDivisions] = useState([]);
    const [{ isPending }, { mutate: fetchDivisions }] = useMutation({
        mutation: API.fetchDictionaries,
        onSuccess: (data) => {
            const receivedDivisions = get(data, 'data.data.product.dictionaries.divisions', []);
            setDivisions(receivedDivisions);
        },
        onFailure: (error) => {
            errorNotification(ajaxExceptionMessage(error));
        },
    });

    return [{ isPending, divisions }, { fetchDivisions }];
};
